class KubeManifestFormController {
  /* @ngInject */
  constructor($async) {
    Object.assign(this, { $async });

    this.methodOptions = [
      { id: 'method_editor', icon: 'fa fa-edit', label: 'Веб-редактор', description: 'Использовать встроенный веб-редактор', value: 'editor' },
      { id: 'method_upload', icon: 'fa fa-upload', label: 'Загрузка файла', description: 'Загрузить файл с компьютера', value: 'upload' },
      { id: 'method_repository', icon: 'fab fa-github', label: 'Репозиторий', description: 'Использовать репозиторий Git', value: 'repository' },
    ];

    this.onChangeFileContent = this.onChangeFileContent.bind(this);
    this.onChangeFormValues = this.onChangeFormValues.bind(this);
    this.onChangeFile = this.onChangeFile.bind(this);
    this.onChangeMethod = this.onChangeMethod.bind(this);
  }

  onChangeFormValues(values) {
    this.formValues = values;
  }

  onChangeFileContent(value) {
    this.state.isEditorDirty = true;
    this.formValues.StackFileContent = value;
  }

  onChangeFile(value) {
    return this.$async(async () => {
      this.formValues.StackFile = value;
    });
  }

  onChangeMethod(method) {
    this.state.Method = method;
  }
}

export default KubeManifestFormController;
